import { httpGet } from "../Web"
import { ApiResponse } from "./ApiResponse";

export interface Unsupported {
    workshopProductId: number,
    testCaseId: number,
    id: number
};

export const getUnsupportedws = (id: number, abortController: AbortController): Promise<ApiResponse<Unsupported[]>> => httpGet(`/api/workshopproduct/unsupportedws/${id}`, new AbortController());
export const getUnsupported = (id: number, abortController: AbortController): Promise<ApiResponse<Unsupported[]>> => httpGet(`/api/workshopproduct/unsupported/${id}`, new AbortController());